import { Injectable } from '@angular/core';
import { TableColumnProvider } from '../../../interfaces/table-column-provider';
import { TableColumn } from '../../../models/table-column';

@Injectable({
    providedIn: 'root'
})
export class TableColumnService {

    private registeredProviders: TableColumnProvider[] = [];

    constructor() {}

    public registerProvider(provider: TableColumnProvider): void {
        this.registeredProviders.push(provider);
    }

    protected getProvidersFor(entityClass: string): TableColumnProvider[] {
        const providers = this.registeredProviders
            .filter((p) => p.supports(entityClass));
        if (providers.length === 0) {
            throw new Error(`No TableColumnService descendant implemented and registered for "${entityClass}".`);
        }
        return providers;
    }

    public getColumnsForEntity(entityClass: string): TableColumn[] {
        const columns = this.getProvidersFor(entityClass)
            .map((p) => p.ids().map((id) => p.get(id)))
            .flat();
        if (columns.length === 0) {
            throw new Error(`No columns defined for entity "${entityClass}".`);
        }
        return columns;
    }

    public get(id: string): TableColumn {
        const provider = this.registeredProviders
            .find((p) => p.ids().indexOf(id) !== -1);
        if (provider) {
            return provider.get(id);
        }
        throw new Error(`Unrecognized column "${id}"`);
    }

    public has(id: string): boolean {
        return !!this.registeredProviders
            .find((p) => p.ids().indexOf(id) !== -1);
    }

    public defined(id: string): boolean {
        return !!this.registeredProviders.find((p) => p.ids().indexOf(id) !== -1);
    }
}
